(function () {
  var HIDE_KEY = "kayerPlNews5Hidden";
  var DONE_KEY = "kayerPlNews5Done";
  var CONFIRMED_COOKIE = "kayer_pl_promo_confirmed";
  var LEGACY_COOKIE = "kayer_pl_promo_sub";
  var COOKIE_DAYS = 60;
  var DELAY_DESKTOP = 6500;
  var DELAY_MOBILE = 3800;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function isMobileViewport() {
    try {
      return window.matchMedia("(max-width: 767px)").matches;
    } catch (err) {
      return false;
    }
  }

  function showDelay() {
    return isMobileViewport() ? DELAY_MOBILE : DELAY_DESKTOP;
  }

  function promoCode(widget) {
    return (widget && widget.getAttribute("data-kayer-pl-promo-code")) || "KAYERPL5";
  }

  function getCookie(name) {
    try {
      var parts = document.cookie ? document.cookie.split("; ") : [];
      var prefix = name + "=";
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(prefix) === 0) {
          return decodeURIComponent(parts[i].slice(prefix.length));
        }
      }
    } catch (err) {}
    return "";
  }

  function setCookie(name, value, days) {
    try {
      var maxAge = days * 24 * 60 * 60;
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; path=/; max-age=" +
        maxAge +
        "; SameSite=Lax" +
        secure;
    } catch (err) {}
  }

  function isPromoConfirmed(widget) {
    if (widget.getAttribute("data-kayer-pl-promo-confirmed") === "1") return true;
    return !!getCookie(CONFIRMED_COOKIE);
  }

  function markConfirmed(widget) {
    setCookie(CONFIRMED_COOKIE, promoCode(widget), COOKIE_DAYS);
    try {
      window.localStorage.setItem(DONE_KEY, "1");
    } catch (err) {}
  }

  function markPendingDone() {
    try {
      window.localStorage.setItem(DONE_KEY, "1");
    } catch (err) {}
  }

  function isCartPage() {
    var path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
    return path === "/cart" || /\/cart$/.test(path);
  }

  function shouldNeverShow(widget) {
    if (isCartPage()) return true;
    if (isPromoConfirmed(widget)) return true;
    try {
      if (window.localStorage.getItem(DONE_KEY) === "1") return true;
      if (window.sessionStorage.getItem(HIDE_KEY) === "1") return true;
    } catch (err) {}
    return false;
  }

  function hideNeonPromo() {
    var neon = document.querySelector("[data-neon-promo-widget]");
    if (!neon) return;
    neon.setAttribute("hidden", "hidden");
  }

  function openWidget(widget) {
    hideNeonPromo();
    widget.removeAttribute("hidden");
    document.body.classList.add("kayer-pl-news-open");
    try {
      document.dispatchEvent(new CustomEvent("kayer-pl-news:open"));
    } catch (err) {}
  }

  function closeWidget(widget) {
    widget.setAttribute("hidden", "hidden");
    document.body.classList.remove("kayer-pl-news-open");
    try {
      document.dispatchEvent(new CustomEvent("kayer-pl-news:closed"));
    } catch (err) {}
  }

  /** Dla luxio-neon-promo-widget.js — czy −5% ma się jeszcze pokazać. */
  window.kayerPlNewsletterWantsToShow = function () {
    var widget = document.querySelector("[data-kayer-pl-news]");
    if (!widget) return false;
    return !shouldNeverShow(widget);
  };

  ready(function () {
    var widget = document.querySelector("[data-kayer-pl-news]");
    if (!widget) return;

    if (getCookie(LEGACY_COOKIE) && !getCookie(CONFIRMED_COOKIE)) {
      try {
        document.cookie = LEGACY_COOKIE + "=; path=/; max-age=0; SameSite=Lax";
      } catch (err) {}
    }

    if (isPromoConfirmed(widget)) {
      markConfirmed(widget);
    }

    var form = document.getElementById("KayerPlNews5Form");
    var tagsInput = widget.querySelector("[data-kayer-pl-news-tags]");
    var phoneInput = widget.querySelector("[data-kayer-pl-news-phone]");
    var hasSuccess = !!widget.querySelector("[data-kayer-pl-news-success]");
    var hasCodeBox = !!widget.querySelector("[data-kayer-pl-promo-display]");

    var singleOptIn = widget.getAttribute("data-kayer-pl-single-opt-in") === "1";

    if (hasSuccess) {
      if (hasCodeBox || singleOptIn) {
        markConfirmed(widget);
      } else {
        markPendingDone();
      }
    }

    var close = widget.querySelector("[data-kayer-pl-news-close]");
    if (close) {
      close.addEventListener("click", function (e) {
        e.preventDefault();
        closeWidget(widget);
        try {
          window.sessionStorage.setItem(HIDE_KEY, "1");
        } catch (err) {}
      });
    }

    var copyBtn = widget.querySelector("[data-kayer-pl-copy-code]");
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var codeEl = widget.querySelector("[data-kayer-pl-promo-display]");
        var code = codeEl ? codeEl.textContent.trim() : "";
        if (!code) return;
        var done = function () {
          copyBtn.classList.add("is-copied");
          copyBtn.textContent = copyBtn.getAttribute("data-copied-label") || "OK";
          window.setTimeout(function () {
            copyBtn.classList.remove("is-copied");
            copyBtn.textContent = copyBtn.getAttribute("data-copy-label") || "Copy";
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }

    if (form && tagsInput) {
      form.addEventListener("submit", function () {
        var ph = phoneInput ? phoneInput.value.replace(/\D/g, "") : "";
        var base = "newsletter, pl-promo-5";
        if (ph.length >= 9) {
          tagsInput.value = base + ", pl-promo-phone-" + ph.slice(-12);
        } else {
          tagsInput.value = base;
        }
      });
    }

    if (hasSuccess) {
      openWidget(widget);
      return;
    }

    if (shouldNeverShow(widget)) {
      widget.setAttribute("hidden", "hidden");
      return;
    }

    window.setTimeout(function () {
      if (shouldNeverShow(widget)) return;
      openWidget(widget);
    }, showDelay());
  });
})();
